















































































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, reactive, SetupContext } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Template = {
  id: string,
  name: string,
  created_at: string,
  updated_at: string,
  organization_id: string,
  is_vertical: boolean,
  has_description: boolean,
  has_image: boolean,
  has_spec: boolean,
  editing?: boolean
}

export default defineComponent({
  name: "CPTemplate",
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: "stylesheet", type: "text/css", href: "/css/style.css" },
      { rel: "stylesheet", type: "text/css", href: "/css/login/template.css" }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" }
    ]
  },

  setup(_, context: SetupContext) {
    const state = reactive({
      templates: [] as Template[],
    });

    async function listTemplates() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.get('dev', '/cptemplates', options).then(response => {
        console.log(response);
        state.templates = response.data;
      }).catch(err => {
        console.log(err);
      });
    }
    listTemplates();

    async function updateTemplateName(t: Template) {
      console.log(t);
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        body: t
      }

      API.put('dev', '/cptemplates', options).then(response => {
        console.log(response);
      }).catch(err => {
        console.log(err);
      });

      toggleNameEdit(t.id);
    }

    function toggleNameEdit(id: string) {
      console.log(id);
      state.templates = state.templates.map(t => {
        if (t.id === id) {
          t.editing = t.editing ? false : true;
        }
        return t;
      });
    }

    return {
      state,
      toggleNameEdit,
      updateTemplateName
    };
  }
});
